<div class="cart-summary">
  <span>
    <a (click)="isCollapsed = !isCollapsed" data-testing-id="promo-collapse-link"
      >{{ 'dias.shopping_cart.promotional_code.heading' | translate }} <fa-icon [icon]="['fas', 'angle-down']"></fa-icon
    ></a>
  </span>

  <ish-error-message [error]="promotionError$ | async" [toast]="toast"></ish-error-message>

  <ish-success-message
    *ngIf="displaySuccessMessage"
    message="shopping_cart.promotion.qualified_promo.text"
    [toast]="toast"
  ></ish-success-message>

  <div
    class="cart-apply-promo form-inline justify-content-between"
    [ngbCollapse]="isCollapsed"
    data-testing-id="promo-code-form"
  >
    <input
      [formControl]="codeInput"
      (keydown.enter)="submitPromotionCode()"
      class="form-control"
      type="text"
      [maxlength]="codeMaxLength"
      [placeholder]="'dias.shopping_cart.promotional_code.label' | translate"
      class="text-center input-btn"
    />

    <button
      type="button"
      class="btn btn-secondary apply-btn"
      [disabled]="!codeInput.valid"
      (click)="submitPromotionCode()"
    >
      {{ 'shopping_cart.promotion.apply.button.label' | translate }}
    </button>
  </div>
</div>
